import { Box, FormControlLabel, Switch } from "@mui/material";
import { useUpdateProjectActiveStatusMutation } from "@repo/server-api";
import { useNotification } from "@repo/shared/components";
import { useTranslation } from "next-i18next";
import React from "react";

import { ProjectContactSection } from "./ProjectContactSection";
import { ProjectIdentification } from "./ProjectIdentification";

import type { ProjectEditProps } from "./ProjectEditProps";

export const GeneralInfoProject = (props: ProjectEditProps) => {
	const { t } = useTranslation();
	const { showNotification } = useNotification();
	const [updateActiveStatus] = useUpdateProjectActiveStatusMutation();

	return (
		<div>
			<div>
				<div className="hrTitle lightGreyFont paddingBottom40">
					<span className="left">{t("profile").toLocaleUpperCase()}</span>
					<hr className="right" />
				</div>
				<Box sx={{ mb: 2 }}>
					<FormControlLabel
						control={
							<Switch
								checked={!props.project.isDeleted}
								onChange={(event) => {
									const newIsDeleted = !event.target.checked;
									updateActiveStatus({
										variables: {
											projectId: props.project.id,
											isDeleted: newIsDeleted,
										},
									}).then((result) => {
										if (result.data?.updateProjectActiveStatus?.boolean) {
											showNotification(
												newIsDeleted ? t("project-inactivated") : t("project-restored"),
												"success",
											);
											props.setProject((prev) => ({ ...prev, isDeleted: newIsDeleted }));
										}
									});
								}}
							/>
						}
						label={t("Active")}
					/>
				</Box>
				<ProjectIdentification
					errors={props.errors}
					project={props.project}
					setProject={props.setProject}
					setErrors={props.setErrors}
				/>
			</div>
			<ProjectContactSection
				errors={props.errors}
				project={props.project}
				setProject={props.setProject}
				setErrors={props.setErrors}
			/>
		</div>
	);
};

GeneralInfoProject.displayName = "GeneralInfoProject";
